module.exports = __webpack_public_path__ + "static/media/Dynamic Map Data GIF.0a87ba76.gif";